export const performanceMark = (name) => {
    if (typeof window !== 'undefined' && 'performance' in window) {
        performance?.mark(name);
    }
};
export const performanceMeasure = (name, startMark, endMark) => {
    if (typeof window !== 'undefined' && 'performance' in window) {
        performance?.measure(name, startMark, endMark);
    }
};
